import {createTheme} from "@aws-amplify/ui-react";
import {studioTheme} from "./ui-components";

// Warm sage-teal palette replacing the default corporate blue
export const appTheme = createTheme({
    name: "appTheme",
    tokens: {
        colors: {
            brand: {
                primary: {
                    10: {value: "hsl(162, 60%, 95%)"},
                    20: {value: "hsl(162, 55%, 87%)"},
                    40: {value: "hsl(162, 50%, 68%)"},
                    60: {value: "hsl(162, 45%, 48%)"},
                    80: {value: "hsl(162, 50%, 35%)"},
                    90: {value: "hsl(162, 55%, 25%)"},
                    100: {value: "hsl(162, 60%, 18%)"},
                },
            },
            background: {
                primary: {value: "hsl(40, 40%, 99%)"},
                secondary: {value: "hsl(162, 25%, 96%)"},
                tertiary: {value: "hsl(162, 20%, 91%)"},
            },
        },
    },
}, studioTheme);
